export default defineNuxtRouteMiddleware((to, from) => {
  const { accessTokenState } = useAuthState();

  if (!to.fullPath.startsWith('/auth') && !to.fullPath.startsWith('/settings')) {
    if (!accessTokenState?.value) {
      return navigateTo('/auth');
    }
  }
});
